import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import PageTitle from '../../common/page-title/index';
import InlineCKEditor from '../../common/editor/inline-editor';
import ContactForm from './contact-us-form-postlogin';
import { getNewContact } from '../../../actions/contacts';
import { loadPageContent } from '../../../actions/content';

import '../styles.css';

class ContactUs extends Component {
  constructor(props) {
    super(props);

    this.pageSlug = 'contact-us-post-login'
  }

  componentDidMount() {
    this.props.dispatch(getNewContact());
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <div className="contact-us container">
        <Row>
          <Col>
            <PageTitle>Contact us</PageTitle>
          </Col>
        </Row>
        <InlineCKEditor identifier={`${this.pageSlug}_content_text`}
                            onContentSaved={this.handleContentSaved}
                            contents={this.props.contents[`${this.pageSlug}_content_text`]}/>
        <Row>
          <Col>
            <ContactForm enquiries={this.props.enquiries}
                         outlets={this.props.outlets}/>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    enquiries: state.registration.contact.enquiries || [],
    outlets:   state.registration.contact.outlets || [],
    contents:  state.content.list
  };
};

export default connect(mapStateToProps)(ContactUs);



// WEBPACK FOOTER //
// ./src/components/contact-us/post-login/index.jsx